<template>
  <div class="style">
  <!-- 轮播 -->
  <section class="notice align-center-main">
    <el-container>
      <el-aside width="200px">
        <nav>
          <div class="entry"><img class="entyimg" width="32" src="@/assets/homePage/iconenty.png" align="middle"><span>快速入口</span></div>
          <router-link to="/navigator/personal/info/property" class="jiaof">我要缴费<img class="iconhot" src="@/assets/homePage/icon-hot.png" alt=""></router-link>
          <router-link :to="{path: `/navigator/property/${commonService.maintain}`}">报修申请</router-link>
          <router-link :to="{path: `/navigator/property/${commonService.newCarCard}`}">车卡新办</router-link>
          <router-link :to="{path: `/navigator/property/${commonService.xuncar}`}">车卡续费</router-link>
          <router-link :to="{path: `/navigator/businessPlatform/businessNav/other/${commonService.advertisingPosition}`}">广告投放</router-link>
          <router-link v-if="this.currentParkId != 1003" :to="{path: `/navigator/businessPlatform/businessNav/other/${commonService.houseProperty}`}">房产租售</router-link>
          <router-link :to="{path: `/navigator/property/${commonService.houserz}`}">入驻办理</router-link>
          <router-link v-if="this.currentParkId == 1003" :to="{path: `/navigator/property/${commonService.bMove}`}">搬迁放行</router-link>
          <router-link :to="{path: `/navigator/businessPlatform/businessNav/other/${commonService.housecd}`}">场地申请</router-link>
          <router-link v-if="this.currentParkId != 1003" :to="{path: `/navigator/businessPlatform/businessNav/meetingRoom/${commonService.meetingRoom}`}">会议室租用</router-link>
          <router-link v-if="this.currentParkId != 1003" to="/navigator/businessPlatform/businessNav/other/1039">天安周转仓</router-link>
          <router-link v-if="this.currentParkId != 1003" to="/navigator/financePlatform/financeInfo/1042">天安专属车险</router-link>
          
          <!-- <router-link to="/index" class="more"><i class="el-icon-caret-right">查看更多</i></router-link> -->
        </nav>
      </el-aside>

          <el-main>
            <Swiper :bannerList="bannerList" swiperHeight="400px" :style="{'width':'785px','margin-left':'5px'}"></Swiper>
            <el-container class="leftjpg">
              <router-link :to="{path: `/navigator/financePlatform/financeInfo/${commonService.tianandai}`}"><img width="390" height='200' src="http://ta-static.tianan.net/Fr3rCZrP_W9C4ktGnXFxBPiiQSAc" alt=""></router-link>
              <router-link :to="{path: `/navigator/financePlatform/financeInfo/${commonService.huawei}`}" class="leftj">
                <img width="390" height='200' src="http://ta-static.tianan.net/FrrVQ3xrJQ1xxm3gkuthHbNbh9mV" alt="">
              </router-link>
            </el-container>
          </el-main>
          <el-main>
            <router-link :to="{path: `/navigator/businessPlatform/businessNav/other/${commonService.advertisingPosition}`}"><img width="200" height='400' src="@/assets/homePage/kd.jpg" alt=""></router-link>
            <el-container class="contfz">
              <router-link to="shoppingMall/mall"><img width="200" height='200' src="@/assets/homePage/fz.jpg" alt=""></router-link>
            </el-container>
          </el-main>
  </el-container>
</section>
<!-- <section class="notice align-center-main" v-if="noticeList.length">
    <router-link tag="div" class="boximg" to="/navigator/notifications">
      <img width="290" height='' src="@/assets/homePage/pic1.jpg" alt="">
    </router-link>
    <router-link tag="div" class="boximg" to="/navigator/notifications">
      <img width="290" height='' src="@/assets/homePage/pic2.jpg" alt="">
    </router-link>
    <router-link tag="div" class="boximg" to="/navigator/notifications">
      <img width="290" height='' src="@/assets/homePage/pic3.jpg" alt="">
    </router-link>
    <router-link tag="div" class="boximg" to="/navigator/notifications">
      <img width="290" height='' src="@/assets/homePage/pic4.jpg" alt="">
    </router-link>
  </section> -->
  <section class="notice align-center-main" v-if="noticeList.length">
    <router-link tag="div" class="boximg lastjpg" to="/navigator/notifications">
       <img width="320" height='200' src="@/assets/homePage/redi.jpg" alt="">
    </router-link>
    <div class="content notifications">
      <ul class="home-note-list">
        <li v-for="(item,index) in noticeList" :key="index" @click="$router.push({ path: `/navigator/notifications/detail/${item.noticeId}` })">
          <span class="textOver">{{ item.createTime | DateFilter("MM-dd") }}</span>
          <span class="noticeTime">{{ item.noticeTitle }}
            <span v-if="parseInt(new Date().getTime())-item.createTime<=parseInt('604800000')?true:false" class="newxin"><img src="@/assets/homePage/icon-hot.png" alt=""></span>
          </span>
        </li>
      </ul>
      <!-- <router-link to="/navigator/notifications" tag="span" class="see_more">查看更多</router-link> -->
    </div>
  </section>
  <section v-if="this.currentParkId != 1003 && this.currentParkId != 1004 && this.currentParkId != 1005" class="activity align-center-main">
    <div class="titleH">
        <h3 class="clcortitle">房产服务</h3>
        <h3 class="sanj"></h3>
        <span class="checkMore" @click="$router.push('/navigator/businessPlatform/businessNav/other/1062')">更多>>></span>
    </div>
    <router-link tag="div" class="leftimg" to="/navigator/businessPlatform/businessNav/other/1062">
      <img width="" height='' src="@/assets/homePage/image-cd2.jpg" alt="">
    </router-link>
    <ul class="office clearfix" v-if="categoryList.length">
      <li class="boxShadow" v-for="(item2, index) in categoryList" :key="index" @click="jumpDetails(item2.facilitiesId)">
        <h3 class="textOver">{{ item2.title }}</h3>
        <img :src="item2.banner" alt="">
      </li>
    </ul>
  </section>
   <section class="activity align-center-main">
    <div class="titleH">
        <h3 class="clcortitle">园区活动</h3>
        <h3 class="sanj"></h3>
        <ul class="ultitle">
          <li><router-link tag="a" to="/navigator/parkCompleteSet/activity">促销优惠</router-link></li>
          <!-- <li><router-link tag="a" to="/navigator/parkCompleteSet/activity">会议沙龙</router-link></li>
          <li><router-link tag="a" to="/navigator/parkCompleteSet/activity">社交圈层</router-link></li>
          <li><router-link tag="a" to="/navigator/parkCompleteSet/activity">活动评比</router-link></li> -->
          <li><router-link tag="a" to="/navigator/parkCompleteSet/activity">专属福利</router-link></li>
        </ul>
        <span class="checkMore" @click="$router.push('/navigator/parkCompleteSet/activity')">更多>>></span>
    </div>
    <div class="leftimg">
      <div style="width:196px;float:left;margin-right:10px;">
        <img width="196" height='100' src="@/assets/homePage/Brand_2.jpg" alt="">
        <img width="196" height='100' src="@/assets/homePage/Brand_3.jpg" alt="">
        <img width="196" height='100' src="@/assets/homePage/Brand_4.jpg" alt="">
      </div>
      <el-row class="content row-bg" type="flex" justify="flex-start">
      <el-col v-for="(item, index) in activityList" :key="index" class="boxShadow">
        <div class="title"  @click="$router.push({ path: `/navigator/activityDetails/${item.activityId}` })">
          <h4 class="doubleTextOver">{{ item.title }}</h4>
          <p class="time">开始时间： {{ item.beginTime | DateFilter('yyyy-MM-dd') }}</p>
          <!-- <p class="price" v-if="item.price === 0"> 价格：免费</p> -->
          <!-- <p class="price" v-else>价格： {{ item.price/100.0  | PriceFilter}} 元</p> -->
        </div>
        <div class="state">{{(item.joinEndTime,item.beginTime,item.endTime) | stateFilter(item.joinEndTime,item.beginTime,item.endTime)}}</div>
        <img :src="item.banner"  @click="$router.push({ path: `/navigator/activityDetails/${item.activityId}` })">
      </el-col>
    </el-row>
    </div>
  </section>
    <!-- <el-row class="common_services row-bg" type="flex" justify="space-between">
      <router-link tag="span" :to="{path: `/navigator/property/${commonService.maintain}`}">
        <el-col :span="4" class="boxShadow">
          <div class="icon"><img src="@/assets/homePage/icon_wuye.png" alt="物业报修"></div>
          <span>报修申请</span>
        </el-col>
      </router-link>
    </el-row> -->

  <!-- <section class="serviceStyle clearfix">
    <div class="align-center-main">
      <template v-for="(item, i) in serviceList">
        <router-link tag="div" v-if="serviceAttr[i].path"
                     :style="{'background-image': 'url(' + serviceAttr[i].bgImage + ')'}"
                     :to="serviceAttr[i].path">
          <img :src="item.picUrl" class="icon">
          <div class="title">{{item.serviceName}}</div>
          <div class="desc">{{item.content}}</div>
        </router-link>
        <div v-else @click="commingSoon" :style="{'background-image': 'url(' + serviceAttr[i].bgImage + ')'}">
          <img :src="item.picUrl" class="icon">
          <div class="title">{{item.serviceName}}</div>
          <div class="desc">{{item.content}}</div>
        </div>
      </template>
    </div>
  </section> -->
  <!-- <section class="align-center-main activity" v-if="activityList.length">
    <div class="header">
      <h3>园区活动</h3>
      <span class="checkMore" @click="$router.push('/navigator/parkCompleteSet/activity')">查看更多</span>
    </div>
    <el-row class="content row-bg" type="flex" justify="flex-start">
      <el-col v-for="(item, index) in activityList" :key="index" class="boxShadow">
        <div class="state">{{(item.joinEndTime,item.beginTime,item.endTime) | stateFilter(item.joinEndTime,item.beginTime,item.endTime)}}</div>
        <img :src="item.banner"  @click="$router.push({ path: `/navigator/activityDetails/${item.activityId}` })">
        <div class="title"  @click="$router.push({ path: `/navigator/activityDetails/${item.activityId}` })">
          <h4 class="doubleTextOver">{{ item.title }}</h4>
          <p class="time">开始时间： {{ item.beginTime | DateFilter('yyyy-MM-dd hh:mm') }}</p>
          <p class="price" v-if="item.price === 0"> 价格：免费</p>
          <p class="price" v-else>价格： {{ item.price/100.0  | PriceFilter}} 元</p>
        </div>
      </el-col>
    </el-row>
  </section> -->
  <!-- <section class="welfare align-center-main" v-if="welfareList.length">
    <div class="header">
      <h3>专享福利</h3>
      <span class="checkMore" @click="$router.push({ path:'/navigator/parkCompleteSet/exclusiveActivities'})">查看更多</span>
    </div>
    <el-row class="content row-bg" type="flex" justify="space-between">
      <el-col class="box boxShadow" v-for="(item, index) in welfareList" :key="index" @click="$router.push({ path: `/navigator/exclusiveActivitiesdetails/${item.welfareId}` })">
        <img :src="item.banner" alt="" @click="$router.push({ path: `/navigator/exclusiveActivitiesdetails/${item.welfareId}` })">
        <div class="imgContent" @click="$router.push({ path: `/navigator/exclusiveActivitiesdetails/${item.welfareId}` })">
          <h4 class="textOver">{{item.title}}</h4>
          <p class="youhui doubleTextOver">{{item.discountLimit}}</p>
          <p>福利来自：{{item.providerName}}</p>
          <p class="time">有效期限：{{ item.beginTime | DateFilter }} 至 {{ item.endTime | DateFilter }}</p>
        </div>
      </el-col>
    </el-row>
  </section> -->
  <!-- <section class="cooperation align-center-main" v-if="CooperationList.length">
    <div class="header">
      <h3>求购合作</h3>
      <router-link tag="span" class="checkMore" to="/navigator/bbs/bbsNav/cooperation">查看更多</router-link>
    </div>
    <el-row class="content row-bg" type="flex" justify="space-between">
      <router-link :to="{ path: `/navigator/bbs/cooperationDetails/${item.serviceId}` }" v-for="item in CooperationList" :key="item.serviceId">
        <List :msg="item"></List>
      </router-link>
    </el-row>
  </section> -->
  <!-- <div class="famous_customers">
    <div class="customers_title"><span>知名客户</span></div>
    &lt;!&ndash; TODO &ndash;&gt;
    <ul class="logo">
      <li>
        <div class="logo_content">
        </div>
      </li>
      <li>
        <div class="logo_content">
        </div>
      </li>
      <li>
        <div class="logo_content">
        </div>
      </li>
      <li>
        <div class="logo_content">
        </div>
      </li>
      <li>
        <div class="logo_content">
        </div>
      </li>
    </ul>
  </div> -->
  </div>
</template>


<script>
import { mapGetters, mapMutations } from 'vuex';
import List from '@/pages/navigator/bbs/components/List';
import Swiper from '@/components/Swiper';
import commonService from '@/static/commonService';

export default {
  data() {
    return {
      changTime: 5000,   // 轮播时间
      maskFlag: false,
      videoUrl: '',
      bannerList: [],   // 轮播数据
      noticeList: [],   // 通知数据
      activityList: [],    // 活动数据
      welfareList: [],   // 福利
      CooperationList: [],   // 合作
      serviceList: [],    // 八大服务
      serviceAttr: [],// 八大服务固定属性
      commonService: {},
      categoryList: [],
      pageTotal: 0,
      pageIndex: 1,
    }
  },
  methods: {
    ...mapMutations(['change_parkServiceList', 'change_currentParkId']),
    getBanner() {  // 获取首页轮播和通知
      this.$http.post(`${this.URL_PREFIX}/app/get/park/banner/index`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.bannerList = res.resData.bannerList;
          this.noticeList = res.resData.noticeList;
        }
      });
    },
    getList() {  // 获取列表
    // console.log(commonService)
      this.$http.post(`${this.URL_PREFIX}/app/get/facilities/rent/list`, {
        parkId: this.currentParkId,
        serviceId: this.commonService.houseProperty,
        currPage: this.pageIndex,
        pageRows: 24,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.categoryList = res.resData.pageList.length > 4 ? res.resData.pageList.slice(0,4) : res.resData.pageList;
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
    jumpDetails(index) {
      this.$router.push({ path: `/navigator/businessPlatform/OtherDetail/${index}`, query: { serviceId: 1062 } })
    },
    getIndexMsg() {  // 获取首页活动
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/index`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.activityList = res.resData.activityList;
          this.welfareList = res.resData.welfareList;
          this.CooperationList = res.resData.askList;
          if (this.CooperationList.length > 2) {
            this.CooperationList.length = 2;
          }
        }
      });
    },
    getService() {  // 获取六大服务
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.serviceList = res.resData.pageList;
          let arr = [];
          this.serviceList.forEach((val) => {
            arr.push({
              serviceFlag: val.serviceFlag,
              serviceName: val.serviceName,
              serviceId: val.serviceId,
              children: val.childrenList
            })
          });
          this.change_parkServiceList(arr);
        }
      });
    },
    commingSoon(){
      this.$alert('内容丰富中，敬请期待', '敬请期待');
    },
    setServiceAttr() {
      this.serviceAttr = [
        {
          'bgImage': require('@/assets/homePage/image_wuye.png'),
          'path': '/navigator/property/' + this.commonService.maintain,
        },
        {
          'bgImage': require('@/assets/homePage/image_shangwu.png'),
          'path': '/navigator/businessPlatform/businessNav',
        },
        {
          'bgImage': require('@/assets/homePage/image_jinrong.png'),
          'path': '/navigator/financePlatform/financeList',
        },
        {
          'bgImage': require('@/assets/homePage/image_yuanqu.png'),
          'path': '/navigator/parkCompleteSet/foodCourt',
        },
        {
          'bgImage': require('@/assets/homePage/image_yingxiao.png'),
          'path': '/navigator/production',
        },
        {
          'bgImage': require('@/assets/homePage/image_xinxi.png'),
          'path': '/navigator/bbs/bbsNav/cooperation',
        },
        {
          'bgImage': require('@/assets/homePage/image_zhengwu.png'),
          'path': '/navigator/governmentAffairsPlatform',
        },
        {
          'bgImage': require('@/assets/homePage/image_renli.png'),
          'path': '/navigator/humanResource/sort/jobList',
        },
      ]
    },
  },
  created() {
    if(this.$route.query.parkId){
      this.change_currentParkId(Number(this.$route.query.parkId));
    }
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
    this.setServiceAttr();
    this.getBanner();
    this.getIndexMsg();
    this.getService();
    this.getList();
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'user']),
  },
  components: {
    List, Swiper
  },
  watch: {
    $route() {
      this.getList();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.jiaof{
  font-size: 22px !important;
  color: #4dbde9 !important;
  position: relative;
  .iconhot{
    position: absolute;
    top: -4px;
    right: 40px;
  }
}
.office {
  border-bottom: 1px solid #e4e1e1;
  border-right: 1px solid #e4e1e1;
  li {
    float: left;
    width: 236px;
    height: 222px;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
    background-color: #fff;
    &:nth-of-type(4n) {
      margin-right: 0;
    }
    img {
      width: 100%;
      height: 160px;
      border-radius: 4px 4px 0 0;
    }
    h3 {
      height: 62px;
      line-height: 62px;
      text-align: center;
      padding: 0 20px;
    }
  }
}
.style {
  background-color: #f5f5f5;
  overflow-x: hidden;
  overflow-y: hidden;
  .align-center-main {
  }
}
.leftjpg{
  img{
    margin-top: 5px;
    margin-right: 5px;
    margin-left: 5px;
  }
  .leftj>img{
    margin-right: 0px;
    margin-left: 0px;
  }
}
.contfz{
  img{
    margin-top: 2px;
  }
}
.el-aside{
  background: #24313a;
  display: flex;
  height: 605px;
  .entry{
    height: 68px;
    width: 100%;
    margin-bottom: 4px;
    color: #fff;
    font-size: 22px;
    text-align: center;
    line-height: 68px;
    .entyimg{
      margin: 0px 6px 16px -26px;
    }
    span{
      border-bottom: 3px solid red;padding-bottom: 8px;
    }
  }
  .more{
    display: inline-block;
    height: 60px;
    width: 100%;
    color: #fff;
    font-size: 20px;
    text-align: center;
    line-height: 60px;
    background: #de2c32;
    margin-bottom: 0px;
  }
  a:not(.more){
    display: inline-block;
    height: 44px;
    width: 100%;
    margin-bottom: 2px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 44px;
    &:hover{
      color: #ffaa00;
    }
  }
}
.el-main{
  padding: 0px;
  // margin-right: 10px;
  &:last-child{
    margin-right: 0px;
  }
}
.mask {
  @include swiper_mask;
}
// carousel start
.el-carousel__item img, .el-carousel__item video {
  width: 100%;
  height: 100%;
  position: relative;
}
.el-carousel__item .videos {
  width: 800px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.el-carousel__item {
  background-color: #e4e4e4;
  color: #000;
  .playVideo {
    position: absolute;
    width: 100px;
    height: 100px;
    background-color: rgba(0,0,0,.8);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 80px;
    }
    &:hover {
      background-color: #000;
      i {
        color: #e4e4e4;
      }
    }
  }
  img.hasUrl {
    cursor: pointer;
  }
}

// carousel end
section {
  .header {
    line-height: 40px;
    h3 {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 14px;
      display: inline-block;
    }
    .color1{
      font-size: 40px;
    }
    .color11{
      color: #cf383f;
    }
    .color12{
      color: #7719ab;
    }
    .color13{
      color: #ffc766;
    }
    .color14{
      color: #28cacc;
    }
    .color15{
      color: #0078d7;
    }
    .title{
      font-size: 16px;
      margin-left: 20px;
      color: #000;
    }
    .checkMore:hover {
      color: #397BC8;
    }
    .checkMore {
      float: right;
      font-size: 16px;
      cursor: pointer;
    }
    .slogen {
      font-size: 20px;
      color: #666;
    }
  }
}
// notice start
.notice {
  display: flex;
  margin-top: 30px;
  margin-bottom: 30px;
  .aside {
    width: 220px;
    background-color: #fff;
    font-size: 24px;
    font-weight: 600;
    color: #000;
    font-style: italic;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 218px;
    .orange {
      color: rgb(223,123,24);
    }
  }
  .boximg{
    margin-left: 14px;
    cursor: pointer;
    &:first-child{
      margin-left: 0px;
    }
  }
  .lastjpg{
    height: 200px;
  }
  .content {
    padding: 26px 0px;
    flex: 1;
    min-width: 880px;
    background-color: #fff;
    // margin-left: 20px;
    overflow: hidden;
    display: flex;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 50%;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow: hidden;
        background-color: #fff;
        line-height: 35px;
        font-size: 16px;
        &:hover{
          & span{
            color:#397BC8;
          }
        }
        span{
          display: inline;
        }
        .noticeTime {
          position: relative;
          font-size: 14px;
          padding-left: 20px;
          &:hover {
            color:#397BC8;
          }
        }
        .newxin{
          position: absolute;
          top: -22px;
          right: -22px;
        }
      }
    }
    .see_more {
      width: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      &:hover{
        color: #397BC8;
      }
    }
  }

  span, li{
    cursor: pointer;
  }

}
// notice end

// activity start

.activity:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear:both;
    visibility: hidden;}
.activity {
  min-height: 200px;
  margin-top: 30px;
  margin-bottom: 30px;
  .common_services {
    min-width: 1184px;
    .boxShadow{
      background-color: #fff;
      cursor: pointer;
    }
    .el-col {
      width: 285px;
      height: 88px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon{
        flex: 1;
        display: flex;
        justify-content: center;
        img{
          max-width: 44px;
          max-height: 44px;
        }
      }
      span {
        flex: 2;
        font-size: 20px;
        color: #333;
        font-weight: bold;
      }
    }

  }
  .titleH{
    border-top: 3px solid #ffaa00;
    background-color: #efefef;
    display: flex;
    position: relative;
    .clcortitle{
      display: inline-block;
      height: 30px;
      width: 135px;
      padding: 8px 30px;
      background: #ffaa00;
      color: #fff;
      font-size: 18px;
    }
    .sanj{
      display: inline-block;
      width: 0px;
      height:0px;
      border-top: 24px solid transparent;
      border-right: 16px solid transparent;
      border-left: 16px solid #ffaa00;
      border-bottom: 22px solid transparent;
    }
    .ultitle{
      li{
        a{
          border-right: 1px solid #000;
          padding-right: 10px;
        }
        float: left;
        line-height: 40px;
        font-size: 16px;
        margin-right: 6px;
      }
      margin: 0 100px 0 11px;
      line-height: 40px;
    }
    .checkMore{
      line-height: 40px;
      color: red;
      position: absolute;
      right: 10px;
    }
  }
  .leftimg{
    float: left;
    overflow: hidden;
    border-bottom: 1px solid #e4e1e1;
  }
  .divborder{
    .onediv{
      width: 400px;
      height: 6px;
      float: left;
      transform:translate(0px,-12px);
    }
    .onediv1{
      background: #cf383f;
    }
    .onediv2{
      background: #7719ab;
    }
    .onediv3{
      background: #ffc766;
    }
    .onediv4{
      background: #28cacc;
    }
    .onediv5{
      background: #0078d7;
    }
    .twodiv{
      width: 800px;
      float: right;
      height: 2px;
      background: #adabab;
      transform:translate(0px,-10px);
    }
    
  }
  .imgcont{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    cursor: pointer;
    align-content: stretch;
    .imgright{
      width: 800px;
      height: 474px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-bottom: 10px;
      .imgleft{
        // height: 28px;
      }
      img{
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .doubleTextOver {
    word-wrap:break-word;
    height: 56px;
    line-height: 28px;
    overflow: hidden;
  }
  .content {
    // min-width: 1184px;
    .el-col {
      float: left;
      width: 285px;
      height: 288px;
      margin-right: 20px;
      background-color: #fff;
      .title {
        padding: 10px 15px;
      }
      h4 {
        width: 100%;
        height: 56px;
        overflow: hidden;
        font-size: 16px;
        font-weight: 600;
        line-height: 26px;
        margin-bottom: 5px;
        cursor: pointer;
        color: #333;
      }
      .time {
        font-size: 14px;
        color: #666;
      }
      .price {
        color: #D92121;
      }
      .state {
        background-color: #D92121;
        font-size: 16px;
        position: absolute;
        z-index: 999;
        margin-top: 16px;
        color: #fff;
        border-radius: 3px;
        padding: 2px 16px;
      }
      img {
        position: relative;
        width: 100%;
        height: 160px;
        cursor: pointer;
        border-radius: 4px 4px 0 0;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
// activity end

// welfare start
.welfare{
  min-height: 220px;
  margin-top: 44px;
  margin-bottom: 20px;
  .content {
    min-width: 1184px;
  }
  .box:hover {
    -webkit-box-shadow: 2px 2px 5px #666;
    box-shadow: 2px 2px 5px #666;
    border-radius: 4px;
  }
  .box {
    // flex: 1;
    width: 590px;
    display: flex;
    float: left;
    height: 126px;
    background-color: #fff;
    cursor: pointer;
    &:first-of-type{
      margin-right: 20px;
    }
    img {
      width: 168px;
      height: 126px;
      border-radius: 4px 0 0 4px;
    }
    .imgContent {
      flex: 1;
      padding-left: 20px;
      padding-top: 15px;
      h4 {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        line-height: 30px;
        width: 380px;
      }
      .youhui {
        color: #de2c32;
        font-size: 14px;
        width: 380px;
        height: 20px;
        font-weight: 600;
        margin: 5px 0;
      }
      p {
        word-wrap:break-word;
        line-height: 24px;
        overflow: hidden;
        font-size: 12px;
      }
    }
  }
}
.cooperation{
  min-height: 220px;
  margin-bottom: 126px;
  h3 {
    margin-bottom: -16px !important;
  }
  .content {
    min-width: 1184px;
    height: 126px;
  }
  .box {
    // flex: 1;
    width: 590px;
    display: flex;
    float: left;
    height: 126px;
    background-color: #fff;
    cursor: pointer;
    &:first-of-type{
      margin-right: 20px;
    }
    img {
      width: 168px;
      height: 126px;
      border-radius: 4px 0 0 4px;
    }
    .imgContent {
      flex: 1;
      padding-left: 20px;
      h3 {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        line-height: 30px;
        width: 380px;
      }
      p {
        word-wrap:break-word;
        line-height: 20px;
        overflow: hidden;
        font-size: 12px;
      }
    }
  }
}
// welfare end

// 六大服务
.serviceStyle {
  background-color: #ebeae6;
  .align-center-main{
    padding: 60px 0;
    overflow: hidden;

    & > div{
      width: 254px;
      height: 304px;
      text-align: center;
      color: #fff;
      margin-left: 15px;
      float: left;
      line-height: 1;
      cursor: pointer;
      position: relative;
      z-index: 2;
      opacity: .9;
      &:hover{
        opacity: 1;
      }
      &:first-child{
        margin-left: 0;
      }
      .icon{
        margin-top: 65px;
        width: 120px;
        height: 80px;
      }
      .title{
        margin-top: 20px;
        font-size: 24px;
      }
      .desc{
        margin-top: 16px;
        font-size: 16px;
        font-weight: normal;
      }

      &:nth-child(5){
        margin-left: 133px;
      }
      &:nth-child(5), &:nth-child(6), &:nth-child(7), &:nth-child(8){
        margin-top: -58px;
        z-index: 1;
      }
    }
  }
}

// customer start
.customer {
  height: 222px;
  background-color: #050607;
  padding-top: 38px;
  text-align: center;
  .title{
    h3 {
      display: inline-block;
      padding: 0 20px;
      font-size: 20px;
      color: #fff;
    }
    s {
      color: #4e4f4f;
      font-size: 20px;
    }
    h4 {
      font-size: 16px;
      color: #fff;
      line-height: 40px;
    }
  }
  ul {
    width: 850px;
    margin: 0 auto;
    margin-top: 25px;
    li {
      width: 168px;
      height: 126px;
      float: left;
      border-radius: 50%;
      background-color: #fff;
      margin-right: 85px;
      background-image: url('../../static/image/u134.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &:last-of-type{
        margin-right: 0;
      }
    }
  }
}
// customer end
  .famous_customers {
    background-color: #333;
    margin-bottom: 40px;
    padding-top: 40px;
    height: 200px;
    .customers_title {
      margin-left: 40%;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.05em;
      height: 1px;
      border-top: 2px solid #979797;
      text-align: center;
      width: 300px;
      span {
        width: 100px;
        position: relative;
        color: #fff;
        top: -14px;
        background: #333;
        padding: 0 20px;
      }
    }
    .logo {
      height: 100px;
      width: 946px;
      margin: 0 auto;
      margin-top: 40px;
      display: flex;
      font-size: 12px;
      font-weight: 500;
      li {
        flex: 1;
        padding-left: 20px;
        .logo_content {
          height: 100px;
          width: 100px;
          border-radius: 50%;
          overflow: hidden;
          background: #fff;
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue